/**
 * An invite an existing account has to sign in to accept. Kept across the
 * login page so the user comes straight back to the invite afterwards
 * (RouteGuard reads it). Session-only: it never outlives the tab.
 */
const KEY = 'pendingWorkspaceInvite';

export const ACCEPT_INVITE_ROUTE = '/accept-workspace-invite';

export function setPendingInvite(token) {
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    // Storage blocked: the user can still reopen the link from the email.
  }
}

export function getPendingInvite() {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPendingInvite() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}

export const pendingInviteUrl = token => `${ACCEPT_INVITE_ROUTE}?token=${encodeURIComponent(token)}`;
